/* eslint-disable no-tabs */
import React from 'react';
import { segmentTrackEvent } from '../utils';

const Lander = ({
  isMobile,
  hed,
  subhed,
  subhed2,
  text,
  bgImage,
  archImage,
}) => {
  let bgImg = isMobile ? bgImage.mobile : bgImage.desktop;
  let archImg = isMobile ? archImage.mobile : archImage.desktop;

  return (
    <div className='lander'>
     <img className="lander-background" src={bgImg}/>
      <div className='lander-arch-wrapper'>
        <img className="lander-arch" src={archImg}/>
  			<div className='lander-text-wrapper'>
  				<h1 className='lander-hed'>{hed}</h1>
          <div className='lander-line'></div>
          <h3 className='subhed'>{subhed}</h3>
          <h3 className='subhed pink'>{subhed2}</h3>
        </div>
      </div>
      <div className="lander-credit">{bgImage.credit}</div>
      <div className="lander-text">{text}</div>
		</div>
  );
};

export default Lander;
